function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "time_svg__a",
  x1: 0,
  y1: 0,
  x2: "50%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00cc81",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00cbc6",
  offset: "100%"
})));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.74 3.95v9.49c0 .22-.18.4-.41.4h-6.6c-.23 0-.41-.18-.41-.4s.19-.4.41-.4h6.19v-9.1c0-.22.18-.4.41-.4.23.01.41.19.41.41M12 23.2C5.82 23.2.8 18.18.8 12S5.82.8 12 .8 23.2 5.82 23.2 12 18.18 23.2 12 23.2M12 0C5.38 0 0 5.38 0 12s5.38 12 12 12 12-5.38 12-12S18.62 0 12 0",
  fill: "url(#time_svg__a)"
});

function SvgTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "709cc72c83ec6c9828493c285c7ed7fe.svg";
export { SvgTime as ReactComponent };